import { Modal } from '@descomplica/foundation-ui-components';
import styled from 'styled-components';

const MyModal = styled(Modal)`
  position: fixed;
  width: 93%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: 768px) {
    width: 100%;
  }

  @media (min-width: 1024px) {
    width: 100%;
  }

  @media (min-width: 1280px) {
    width: 100%;
  }

  div {
    height: auto;
    width: auto;
    max-width: 602px;
    color: #ffffff;
    background: #222;
  }
`;

const Container = styled.div`
  padding: 48px 32px 16px;
  height: auto;
`;

const Title = styled.h2`
  font-weight: 900;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -1.2px;
  color: #ffffff;
  padding: 0;
  margin: 0;
`;

const Description = styled.div`
  justify-content: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  margin: 8px 0 0;
  padding: 0;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 28px;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  @media (min-width: 1280px) {
    flex-direction: row;
  }
`;

const ConfirmationActionButton = styled.button`
  font-family: Aprova Nova;
  border: none;
  cursor: pointer;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  height: 38px;
  width: 100%;
  border-radius: 300px;
  padding: 12px, 24px, 12px, 20px;
  background-color: #00f99d;
  color: #191a1a;
  top: 1rem;

  display: flex;
  align-items: center;
  justify-content: center;

  & > span {
    padding-left: 5px;
  }
`;

const CancelationActionButton = styled.button`
  font-family: Aprova Nova;
  border: 1px solid #fff;
  cursor: pointer;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  height: 38px;
  width: 100%;
  border-radius: 300px;
  padding: 12px, 24px, 12px, 20px;
  background-color: #222;
  color: #ffffff;
  top: 1rem;

  display: flex;
  align-items: center;
  justify-content: center;

  & > span {
    padding-left: 5px;
  }

  & > svg {
    width: 14px;
    height: 14px;
  }
`;

export {
  Actions,
  CancelationActionButton,
  ConfirmationActionButton,
  Container,
  Description,
  MyModal,
  Title,
};
